import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Card, Grid, InputAdornment, Tooltip, Typography, useMediaQuery } from '@mui/material';

// third-party
import PopupState, { bindPopper, bindToggle } from 'material-ui-popup-state';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import { IconAdjustmentsHorizontal, IconSearch, IconX } from '@tabler/icons-react';

import { useNavigate, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { HeaderAvatarStyle, OutlineInputStyle, PopperStyle } from './styles';
import MobileSearch from './MobileSearch';
import SearchPopOptions from './SearchPopOptions';

// ==============================|| SEARCH INPUT ||============================== //
const SearchSection = () => {
    // hooks
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const intl = useIntl();
    // varss
    const [value, setValue] = useState<string>('');
    const [searchFields, setSearchFields] = useState<string[]>([
        'productName',
        'productIds',
        'skuIds',
        'productRefIds',
        'eans',
        'textLink',
        'skuRefIds'
    ]);
    const [valueIsNumber, setValueIsNumber] = useState<boolean>(true);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [open, setOpen] = useState(false);
    const isMedium = useMediaQuery(theme.breakpoints.down('md'));
    useEffect(() => {
        const isNum = !isNaN(Number(value));
        setValueIsNumber(isNum);
    }, [searchFields, value]);

    const handelFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        setSearchFields((prevSearchField) => {
            let search: string[] = [...prevSearchField];

            if (checked) {
                search = [...search, name];
            } else {
                search = search.filter((item) => item !== name);
            }

            return search;
        });
    };

    const handleEnter = (event: any): void => {
        if (event.key === 'Enter') {
            if (value.length > 0) {
                handleSearch();
            } else {
                navigate({ pathname: '/loolu/admin/products' });
            }
        }
    };

    const handleSearch = () => {
        const params = searchFields;
        // CLOSE
        setAnchorEl(null);

        if (!value) {
            handleCleanSearch();
            return;
        }
        // REDIRECT
        const newSearchParams = new URLSearchParams();
        const regexCheck = /^\d+$/.test(value);
        params.forEach((item) => {
            if (!regexCheck) {
                if (item === 'textLink' || item === 'productName' || item === 'skuRefIds' || item === 'productRefIds' || item === 'eans') {
                    if (!newSearchParams.has(item.toString())) {
                        newSearchParams.append(item.toString(), value);
                    }
                }
            } else {
                if (!newSearchParams.has(item.toString())) {
                    newSearchParams.append(item.toString(), value);
                }
            }
        });
        setValue(value);
        navigate({ pathname: '/loolu/admin/products', search: `?${newSearchParams.toString()}` });
    };
    const handleCleanSearch = () => {
        if (location.pathname === '/loolu/admin/products') {
            setValue('');
            navigate({ pathname: '/loolu/admin/products', search: '' });
            return;
        }

        navigate({ pathname: '/loolu/admin/products', search: `` });
        setValue('');
    };

    const handleButtonOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
        if (open) return;

        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen((prev) => !prev);
    };

    const id = open ? 'simple-popper-a' : undefined;

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (id) {
                const popperNode = document.getElementById(id);
                if (anchorEl && popperNode && !anchorEl.contains(event.target) && !popperNode.contains(event.target)) {
                    setAnchorEl(anchorEl ? null : event.currentTarget);
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [id, anchorEl]);

    return (
        <Box sx={{ position: 'relative' }}>
            {isMedium && (
                <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                    <PopupState variant="popper" popupId="demo-popup-popper">
                        {(popupState) => (
                            <>
                                <Box sx={{ ml: 2 }}>
                                    <HeaderAvatarStyle variant="rounded" {...bindToggle(popupState)}>
                                        <IconSearch stroke={1.5} size="1.2rem" />
                                    </HeaderAvatarStyle>
                                </Box>
                                <PopperStyle {...bindPopper(popupState)} transition>
                                    {({ TransitionProps }) => (
                                        <>
                                            <Transitions type="zoom" {...TransitionProps} sx={{ transformOrigin: 'center left' }}>
                                                <Card
                                                    sx={{
                                                        background: theme.palette.mode === 'dark' ? theme.palette.dark[900] : '#fff',
                                                        [theme.breakpoints.down('sm')]: {
                                                            border: 0,
                                                            boxShadow: 'none'
                                                        }
                                                    }}
                                                >
                                                    <Box sx={{ p: 2 }}>
                                                        <Grid container alignItems="center" justifyContent="space-between">
                                                            <Grid item xs>
                                                                <MobileSearch
                                                                    value={value}
                                                                    setValue={setValue}
                                                                    popupState={popupState}
                                                                    handleEnter={handleEnter}
                                                                    handleOptions={() => {
                                                                        setOpen(false);
                                                                    }}
                                                                    cleanSearch={handleCleanSearch}
                                                                    handleOptionsCick={!open ? handleButtonOptionsClick : () => {}}
                                                                    searchProps={{
                                                                        handleSearch,
                                                                        handelFilter,
                                                                        valueIsNumber,
                                                                        searchFields,
                                                                        show: open,
                                                                        setOpen,
                                                                        id,
                                                                        anchorEl
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Card>
                                            </Transitions>
                                        </>
                                    )}
                                </PopperStyle>
                            </>
                        )}
                    </PopupState>
                </Box>
            )}

            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Tooltip title={<Typography color="inherit">{intl.formatMessage({ id: 'search_for' })}</Typography>}>
                    <OutlineInputStyle
                        id="input-search-header"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder={intl.formatMessage({ id: 'search_product' })}
                        onKeyDown={handleEnter}
                        startAdornment={
                            <InputAdornment position="start">
                                <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                            </InputAdornment>
                        }
                        endAdornment={
                            <InputAdornment position="end">
                                <HeaderAvatarStyle variant="rounded" onClick={handleButtonOptionsClick}>
                                    <IconAdjustmentsHorizontal stroke={1.5} size="1.3rem" />
                                </HeaderAvatarStyle>
                                {value.length > 0 && (
                                    <Box sx={{ ml: 2 }} onClick={handleCleanSearch}>
                                        <Avatar
                                            variant="rounded"
                                            sx={{
                                                ...theme.typography.commonAvatar,
                                                ...theme.typography.mediumAvatar,
                                                background:
                                                    theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.orange.light,
                                                color: theme.palette.orange.dark,
                                                '&:hover': {
                                                    background: theme.palette.orange.dark,
                                                    color: theme.palette.orange.light
                                                }
                                            }}
                                        >
                                            <IconX stroke={1.5} size="1.3rem" />
                                        </Avatar>
                                    </Box>
                                )}
                                <SearchPopOptions
                                    handleSearch={handleSearch}
                                    handelFilter={handelFilter}
                                    valueIsNumber={valueIsNumber}
                                    searchFields={searchFields}
                                    show={open}
                                    setOpen={setOpen}
                                    id={id}
                                    anchorEl={anchorEl}
                                />
                            </InputAdornment>
                        }
                        aria-describedby="search-helper-text"
                        inputProps={{ 'aria-label': 'weight' }}
                    />
                </Tooltip>
            </Box>
        </Box>
    );
};

export default SearchSection;
